import q from 'q';
/* eslint-disable no-undef */

// Adapted from: https://labs.magnet.me/nerds/2015/11/16/async-await-in-angularjs.html
// Babel will convert "await" to a generator, and then wrap the generator with this function

var getGlobal = function () {
	if (typeof self !== 'undefined') {
		return self;
	}
	if (typeof window !== 'undefined') {
		return window;
	}
	if (typeof global !== 'undefined') {
		return global;
	}
	throw new Error('unable to locate global object');
};

var globals = getGlobal();
var $injector;
var $q = q;
var $rootScope = {
	$evalAsync: () => {},
};

export function $await(generator) {
	return function () {
		var args = arguments;
		var self = this;

		if (!$injector) {
			$injector = globals && globals.angular && globals.angular.element(document).injector();
			if ($injector) {
				$q = $injector && $injector.get('$q');
				$rootScope = $injector && $injector.get('$rootScope');
			}
		}

		var promise = (function () {
			var deferred = $q.defer();
			var iter;

			try {
				iter = generator.apply(self, args);
			} catch (e) {
				deferred.reject(e);
				return;
			}

			function next(val, isError = false) {
				var state;

				try {
					state = isError ? iter.throw(val) : iter.next(val);
				} catch (e) {
					deferred.reject(e);
					return;
				}

				if (state.done) {
					deferred.resolve(state.value);
				} else {
					$q.when(state.value).then(next, function (err) {
						next(err, true);
					});
				}
			}

			next();

			return deferred.promise;
		})();

		return promise['finally'](function () {
			try {
				$rootScope.$evalAsync();
				// eslint-disable-next-line no-empty
			} catch (error) {}
		});
	};
}
